// Fiesta.jsx - Fiesta Theme Store Page
import React from "react";
import "./Fiesta.css";
import medalImage from "../images/medal.jpg";
import { Link } from "react-router-dom";

const Fiesta = () => {
  return (
    <div className="fiesta-page">
     <header className="fiesta-hero">
  <h1 className="animated-fiesta-title">
    <span>🎉</span>
    <span className="letter f">F</span>
    <span className="letter i">I</span>
    <span className="letter e">E</span>
    <span className="letter s">S</span>
    <span className="letter t">T</span>
    <span className="letter a">A</span>
    <span> 🪅</span>
  </h1>
  <p>Support local. Celebrate culture. Collect memories.</p>
</header>

      <section className="fiesta-products">
        <div className="fiesta-card">
          <img src={medalImage} alt="Fiesta Medal 2025" className="fiesta-img" />
          <h2>ASL Fiesta Medal 2025</h2>
          <p className="product-desc">
           
            Show off your Fiesta spirit with our limited-edition ASL Fiesta Medal! Proceeds support local culture & inclusion.
          </p>
          <p className="product-price">$12</p>
          <p className="product-desc promo-highlight">🎉 <strong>Save $2 Pay Only $10!</strong><br/>Order now via <strong className="highlight-link">pay.goourhub.com</strong></p>
          <a
            href="https://pay.goourhub.com"
            target="_blank"
            rel="noopener noreferrer"
            className="buy-btn"
          >
            Buy Now
          </a>
        </div>

        {/* Future items */}
        <div className="fiesta-card coming-soon highlighted-cta">
          <h3>More Fiesta Merch Coming Soon! 🎊</h3>
          <p>🎭 T-Shirts, 🎈Decor, 🧢 Hats & more!</p>
          <div className="cta-highlight">
            <h4>📣 Want to Promote or Sell Your Fiesta-Themed Product?</h4>
            <p>
              <Link to="/contact" className="cta-link">Contact us</Link> or email
              <br/>
              <strong className="cta-email">contact@goourhub.com</strong>
            </p>
          </div>
        </div>
      </section>

      <footer className="fiesta-footer">
        <p>🌟 Thank you for supporting community-led initiatives. 🌟</p>
        <Link to="/" className="back-home">← Back to Home</Link>
      </footer>
    </div>
  );
};

export default Fiesta;
